// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__UZ7RU","contained":"OpenButton_contained__1EWaj","disabled":"OpenButton_disabled__1hVA2","error":"OpenButton_error__10x_e"};